import { Pipe, PipeTransform } from '@angular/core';
import { TableDataType } from '../enums/common.enums';
import { DatetimeService } from '../services/datetime.service';

@Pipe({
    name: 'customFormat',
    standalone: false
})
export class CustomFormatHelper implements PipeTransform {
  constructor(private datetimeService: DatetimeService) {}

  transform(value: any, format?: TableDataType): string | null {
    if (!value) return '';
    switch (format) {
      case TableDataType.LongDate:
        return this.datetimeService.formatDateInUserTimeZone(value, 'dd/MM/yyyy - h:mm aa');
      case TableDataType.ShortDate:
        return this.datetimeService.formatDateInUserTimeZone(value, 'dd/MM/yyyy');
      case TableDataType.StringDate:
        return this.datetimeService.formatDateInUserTimeZone(value, 'MMMM d, yyyy');
      case TableDataType.OnlyTimeDate:
        return this.datetimeService.formatDateInUserTimeZone(value, 'h:mm aa');
      case TableDataType.Mobile:
        return this.maskingMobileNumber(value);
      case TableDataType.Tags:
        return Array.isArray(value) ? value.join(', ') : value;
      default:
        return value;
    }
  }

  maskingMobileNumber(mobileNo: string) {
    if (mobileNo && mobileNo.length === 10) {
      return `${mobileNo.slice(0, 3)}-${mobileNo.slice(3, 6)}-${mobileNo.slice(6)}`;
    } else return mobileNo;
  }
}
